<template>
  <v-container fill-height fluid>
    <v-text-field color="red" :loading="isloading" 
      disabled :hidden="ishidden" :style="ishidden == false ? '' :'display:none'"
      ></v-text-field>
    <v-row>
      <v-col cols=12 md=12 lg=12 sm=12>
        <v-card color="transparent" outlined width="100%" class="">
            <v-toolbar color="transparent" flat class="toobarDashboard" height="40">
                <v-toolbar-title>
                    <v-chip label color="amber"><v-icon class="mr-3">mdi-view-dashboard</v-icon> Dashboard</v-chip>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                    <a v-for="(menu, i) in menuProduct" :key="i" :href="`/orders/${menu.id}`" class="ancSetting">
                    <v-btn color='blue-grey darken-2' dark :class="isopend(menu.id) ? `buttonanimation text-uppercase orderButton ml-5 elevation-0` : `text-uppercase orderButton ml-5 elevation-0`" x-small>
                         {{menu.name}} 
                    </v-btn></a>
                </v-toolbar-items>
            </v-toolbar>         
        </v-card>
      </v-col>
     </v-row>
    <!--<v-row>
        <v-col cols=12 md=3 sm=3>
            <v-card outlined color="primary">
              <v-card-text class="pt-0 pb-0 pl-5 pr-5">
                  <v-row>
                      <v-col cols=4 md=4 sm=4 lg=4>
                          <v-icon class="pa-0" size="50" dark> mdi-send</v-icon>
                      </v-col>
                      <v-col cols=8 md=8 sm=8 lg=8 class="text-right">
                          <p class="mb-0 mt-1 font-weight-bold display-1 white--text">{{submittedRecords}}<br> 
                            <v-chip label class="ml-3 blue--text text--darken-2" color="white">Total Bids</v-chip>
                          </p>
                      </v-col>
                  </v-row>
              </v-card-text>
            </v-card>
        </v-col>
        <v-col cols=12 md=3 sm=3>
            <v-card outlined="" color="#FFCA28">
            <v-card-text class="pt-0 pb-0 pl-5 pr-5">
                <v-row>
                    <v-col cols=4 md=4 sm=4 lg=4>
                        <v-icon dark class="pa-0" size="50"> mdi-alarm-multiple</v-icon>
                    </v-col>
                    <v-col cols=8 md=8 sm=8 lg=8 class="text-right">
                        <p class="mb-0 mt-1 font-weight-bold display-1 white--text">{{penddingRecords}}<br> 
                         <v-chip label class="ml-3 amber--text text--lighten-1" color="white">Pending</v-chip>
                        </p>
                    </v-col>
                </v-row>
            </v-card-text>
            </v-card>
        </v-col>
        <v-col cols=12 md=3 sm=3>
            <v-card outlined="" color="#66BB6A">
            <v-card-text class="pt-0 pb-0 pl-5 pr-5">
                <v-row>
                    <v-col cols=4 md=4 sm=4 lg=4>
                        <v-icon class="pa-0" size="50" dark> mdi-check-all</v-icon>
                    </v-col>
                    <v-col cols=8 md=8 sm=8 lg=8 class="text-right">
                        <p class="mb-0 mt-1 font-weight-bold display-1 white--text"> {{approvedRecord}}<br> 
                          <v-chip label class="ml-3 green--text text--lighten-1" color="white">Approved</v-chip>
                        </p>
                    </v-col>
                </v-row> 
            </v-card-text>
            </v-card>
        </v-col>
        <v-col cols=12 md=3 sm=3>
            <v-card outlined color="#EF5350">
            <v-card-text class="pt-0 pb-0 pl-5 pr-5">
                <v-row>
                    <v-col cols=4 md=4 sm=4 lg=4>
                        <v-icon class="pa-0" size="50" dark> mdi-cancel</v-icon>
                    </v-col>
                    <v-col cols=8 md=8 sm=8 lg=8 class="text-right">
                        <p class="mb-0 mt-1 font-weight-bold display-1 white--text"> {{notApprovedRecords}}<br> 
                          <v-chip label class="ml-3 red--text text--lighten-1" color="white">Not Approved</v-chip>
                        </p>
                    </v-col>
                </v-row>
            </v-card-text>
            </v-card>
        </v-col>
    </v-row>-->
    <!-- Dashboard start Here -->
    <v-row>
      <v-col cols=12 md=4 lg=4 sm=12 v-for="(data ,i ) in dashboardUpdatesData" :key="i" class="mb-5 mt-5">
        <v-card class="cardShadow postionRealtive">
          <v-card-text class="pa-3">
            <v-toolbar flat class="customboxtoolbar" color="transparent">
              <a :href="`/orders/${data.productId}`" class="ancSetting">
                <v-chip pill :class="data.open ? `buttonanimation2` : ''" color="red lighten-4" text-color="red" style="cursor:pointer">{{data.counterA}}</v-chip>
              </a>
              <v-spacer></v-spacer>
                <h2 class="title font-weight-ragular text-uppercase">{{data.productName}}</h2>
                <v-spacer></v-spacer>
                <a :href="`/orders/${data.productId}`" class="ancSetting">
                  <v-chip pill :class="data.open ? `buttonanimation2` : ''" color="red lighten-4" text-color="red" style="cursor:pointer">{{data.counterB}}</v-chip>
                </a>
            </v-toolbar>
          </v-card-text><v-divider></v-divider>
          <v-spacer></v-spacer>
          <v-row align="center" class="DashboardBoxBackendSetting">
            <!-- Format Purchase Form A -->
            <v-col v-if="data.productForm =='PurchaseFormA'" md=12 sm=12 cols=12 lg=12>
              <v-card-text>                
                <v-toolbar flat class="customboxtoolbar" color="transparent" dense>
                    <div class="text-right">
                      <small class="smalltext">Condition</small>
                        <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.conditionRate}}</H1>
                        <small class="smalltext">42% Oil Content</small>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                      <v-btn v-if="role == 'admin'" color="blue-grey darken-2" dark small @click="selectedProduct=data.productId;DailyupdateDailog=true">Update</v-btn>
                      <br>
                      <v-chip pill color="red lighten-4" class="text-uppercase my-2" x-small text-color="red">{{data.productNature}}</v-chip>
                    </div>
                    <v-spacer></v-spacer> 
                    <div class="text-right">
                      <small class="smalltext">Non Condition</small>
                        <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>  {{data.nonConditionRate}}</H1>
                        <small class="smalltext white--text">.</small>
                    </div>
                </v-toolbar>
              </v-card-text>
            </v-col>
            <!-- End Format Purchase Form A -->

            <!-- Format Purchase Form B -->
            <v-col v-if="data.productForm =='PurchaseFormB'" md=12 sm=12 cols=12 lg=12 class="text-center">
              <v-card-text>
                <v-toolbar flat class="customboxtoolbar" color="transparent">
                    <div class="text-right">
                        <small class="smalltext">Solvent Condition</small>
                        <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.conditionRate}}</H1>
                        <small class="smalltext white--text">.</small>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                      <v-btn v-if="role == 'admin'" color="blue-grey darken-2" dark small @click="selectedProduct=data.productId;DailyupdateDailog=true">Update</v-btn>
                      <br>
                      <v-chip pill color="red lighten-4" class="text-uppercase my-2" x-small text-color="red">{{data.productNature}}</v-chip>
                    </div>
                    <v-spacer></v-spacer> 
                    <div class="text-right">
                        <small class="smalltext">Non Condition</small> 
                        <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.nonConditionRate}}</H1>
                        <small class="smalltext white--text">.</small>
                    </div>
                </v-toolbar>
              </v-card-text>
            </v-col>
            <!-- End Format Purchase Form B -->

            <!-- Format Purchase Form C -->
            <v-col v-if="data.productForm =='PurchaseFormC'" md=12 sm=12 cols=12 lg=12 class="text-center">
              <v-card-text>
                <v-toolbar flat class="customboxtoolbar" color="transparent">
                    <div class="text-right">
                      <small class="smalltext">EX-LOOSE RATE</small>
                      <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.looseRatePbHr}}</H1>
                      <small class="smalltext">PB/HR</small>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                      <v-btn v-if="role == 'admin'" color="blue-grey darken-2" dark small @click="selectedProduct=data.productId;DailyupdateDailog=true">Update</v-btn>
                      <br>
                      <v-chip pill color="red lighten-4" class="text-uppercase my-2" x-small text-color="red">{{data.productNature}}</v-chip>
                    </div>
                    <v-spacer></v-spacer> 
                    <div class="text-right">
                      <small class="smalltext">EX-LOOSE RATE</small>
                      <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.looseRateSumerpur}}</H1>
                      <small class="smalltext">Sumerpur</small>
                    </div>
                </v-toolbar>
              </v-card-text>
            </v-col>
            <!-- End Format Purchase Form C -->

            <!-- Format Sale Form A -->
            <v-col v-if="data.productForm =='SaleFormA'" md=12 sm=12 cols=12 lg=12 class="text-center">
              <v-card-text>
                <v-toolbar flat class="customboxtoolbar" color="transparent">
                  <div class="text-right">
                    <small class="smalltext">LOOSE READY</small>                    
                    <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.readyRate}}</H1>
                    <small class="smalltext">Upto {{data.readyLiftingIn}}</small>
                  </div>
                  <v-spacer></v-spacer>
                  <div>
                      <v-btn v-if="role == 'admin'" color="blue-grey darken-2" dark small @click="selectedProduct=data.productId;DailyupdateDailog=true">Update</v-btn>
                      <br>
                      <v-chip pill color="red lighten-4" class="text-uppercase my-2" x-small text-color="red">{{data.productNature}}</v-chip>
                  </div>
                  <v-spacer></v-spacer> 
                  <div class="text-right">
                    <small class="smalltext">LOOSE FORWARD</small>
                    <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.forwardRate}}</H1>
                    <small class="smalltext">Upto {{data.forwardLiftingIn}}</small>
                  </div>
                </v-toolbar>
              </v-card-text>
            </v-col>
            <!-- End Format Sale Form A -->

            <!-- Format Sale Form B -->
            <v-col v-if="data.productForm =='SaleFormB'" md=12 sm=12 cols=12 lg=12 class="text-center">
              <span style="display:none;">{{locationId = data.locationId}}</span>
              <v-card-text>
                <v-toolbar flat class="customboxtoolbar" color="transparent">
                  <div class="text-right">
                    <small  class="smalltext">EX READY</small>
                    <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.readyRate}}</H1>
                    <small class="smalltext">Lifting within {{data.readyLiftingIn}} Days</small>
                  </div>
                  <v-spacer></v-spacer>
                  <div>
                      <v-btn v-if="role == 'admin'" color="blue-grey darken-2" dark small @click="selectedProduct=data.productId;DailyupdateDailog=true">Update</v-btn>
                      <br>
                      <v-chip pill color="red lighten-4" class="text-uppercase my-2" x-small text-color="red">{{data.productNature}}</v-chip>
                  </div>
                  <v-spacer></v-spacer> 
                  <div class="text-right">
                    <small  class="smalltext">EX FORWARD</small>
                    <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.forwardRate}}</H1>
                    <small class="smalltext">Lifting within {{data.forwardLiftingIn}} Days</small>
                  </div>
                </v-toolbar>
              <!--  <v-divider class="my-3"></v-divider>
                <v-toolbar flat class="customboxtoolbar" color="transparent">
                  <div class="text-right">
                    <small class="smalltext">FOR READY</small>
                    <H1> <span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.forReadyRate}}</H1>
                    <small class="smalltext">Lifting within {{data.readyLiftingIn}} Days</small>
                  </div>
                  <v-spacer></v-spacer> 
                  <v-select :items="locationRecord" v-model="locationId" @change="fetchbyloaction()" color="amber" item-text="location" item-value="id" prepend-inner-icon="mdi-search-web" outlined label="Select Locatoin" dense hide-details></v-select>
                  <v-spacer></v-spacer> 
                  <div class="text-right">
                    <small class="smalltext">FOR FORWARD</small>
                    <H1> <span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.forForwardRate}}</H1>
                    <small class="smalltext">Lifting within {{data.forwardLiftingIn}} Days</small>
                  </div>
                </v-toolbar>-->
              </v-card-text>
            </v-col>
            <!-- End Format Sale Form B -->
            <!-- Bottom Data -->
            </v-row>
            <v-toolbar flat class="customboxtoolbar mb-3" color="transparent">
                <v-spacer></v-spacer>
                <a :href="`/orders/${data.productId}/?type=pending`"><v-btn color="amber" x-small>
                  <v-avatar size="15" color="orange" class="mr-3">{{data.pCount}} </v-avatar>Pending</v-btn></a>
                <v-spacer></v-spacer>
                <a :href="`/orders/${data.productId}/?type=approved`"><v-btn color="green" x-small dark :class="data.apopen == true ? 'buttonanimation' : ''" >
                  <v-avatar size="15" color="green darken-2" class="mr-3">{{data.apCount}} </v-avatar> &nbsp;&nbsp; Approved</v-btn></a>
                <v-spacer></v-spacer>
                <a :href="`/orders/${data.productId}/?type=notap`"><v-btn color="red" x-small dark>
                  <v-avatar size="15" color="red darken-2" class="mr-3">{{data.napCount}} </v-avatar> &nbsp;&nbsp; Not Approved</v-btn></a>
                <v-spacer></v-spacer>
              </v-toolbar>

            <v-divider></v-divider>
            <v-card-text class="pa-2">
              <v-toolbar flat class="customboxtoolbar" color="transparent">
                <label class="text-uppercase font-weight-bold caption grey--text text--darken-2">Last Update: {{data.CreatedAt}}</label>
                  <v-spacer></v-spacer>
                  <label class="text-uppercase font-weight-bold caption grey--text text--darken-2">By: {{data.createdBy}}</label> 
              </v-toolbar>
          </v-card-text>
        </v-card>
      </v-col>        
    </v-row>
    <v-snackbar v-model="notificationBar" top center :color="notificationColor" multi-line> {{ notificationText }}
        <v-btn color="amber" text @click="notificationBar = false"> Close </v-btn>
    </v-snackbar>
    <v-dialog v-model="DailyupdateDailog" persistent transition="dialog-bottom-transition" max-width="800px">
      <DailyUpdate @Response="action($event)" @Close="DailyupdateDailog = false" :productId="selectedProduct"></DailyUpdate>
    </v-dialog> 
    <notifications group="foo" position="bottom right" :classes="notificationClasses" />
  </v-container>
</template>

<script>
import { SERVER_API } from '../API'
import {store} from '../store/index'
import DailyUpdate from '../components/dailyupdate/index'
import {bus} from '../main'
export default {
  components:{DailyUpdate},
  mounted(){
    this.fetchDataForDashboard();
    this.fetchApproved();
    this.fetchPending();
    this.fetchSubmitted();
    this.fetchNotApproved();
    this.fetchLocation();
    this.fetchProduct();
                               
    //this.checkUser();
  },
  created(){
      bus.$on('notify',() =>{
          this.fetchDataForDashboard();
          this.fetchApproved();
          this.fetchPending();
          this.fetchSubmitted();
          this.fetchNotApproved();
      })
  },
  data(){
    return{
      role:store.state.role,
      isloading:true,
      ishidden:false,
      menuProduct:[],
      notificationClasses:null,
      dashboardUpdatesData:[],
      DailyupdateDailog:false,
      selectedProduct:'',
      locationId:'',
      locationRecord:[],

      // Counter Var
      approvedRecord:'',
      notApprovedRecords:'',
      submittedRecords:'',
      penddingRecords:'',
      
      // Notification Setting
            notificationColor: 'black',
            notificationBar: false,
            notificationText:'',
    }
  },
  /*created () {
    bus.$on('TESTBRO', (data) => {
      alert(data);
    });
  },*/
  methods:{
    action(e){
            if(e.action == true){
                this.notificationColor = 'black';
                this.notificationBar = true;
                this.notificationText = e.message;
                //this.fetchall();
                this.DailyupdateDailog = false;
                this.fetchDataForDashboard();
                this.fetchApproved();
                this.fetchPending();
                this.fetchSubmitted();
                this.fetchNotApproved();
            }else{
                this.notificationColor = 'red';
                this.notificationBar = true;
                this.notificationText = e.message;
                //console.log(e);
            }
        },
    async fetchbyloaction(){
            const response = await this.$http.get(SERVER_API+'/backend/dashboard/'+this.locationId);
            this.dashboardUpdatesData = response.data;
        },
    async fetchLocation(){
        const response = await this.$http.get(SERVER_API+'/location/records/active');
        this.locationRecord = response.data.data;
    },
    async fetchDataForDashboard(){
      const response = await this.$http.get(SERVER_API+'/backend/dashboard');
      this.dashboardUpdatesData = response.data;
      if(this.dashboardUpdatesData){
        this.ishidden = true;
        this.isloading = false;
      }
    },
    async fetchApproved(){
      const response = await this.$http.get(SERVER_API+'/backend/dashboard/counter/approved');
      this.approvedRecord = response.data
    },
    async fetchPending(){
      const response = await this.$http.get(SERVER_API+'/backend/dashboard/counter/pending');
      this.penddingRecords = response.data
    },
    async fetchSubmitted(){
      const  response = await this.$http.get(SERVER_API+'/backend/dashboard/counter/submitted');
      this.submittedRecords = response.data
    },
    async fetchNotApproved(){
      const response = await this.$http.get(SERVER_API+'/backend/dashboard/counter/notapproved');
      this.notApprovedRecords = response.data
    },
    async fetchProduct(){
      try{
        const response = await this.$http.get(SERVER_API+'/product/byuser');
        this.menuProduct = response.data.data;
      }catch(error){
        alert(error);
      }
    },
    isopend($id){
      if(this.dashboardUpdatesData.length > 0){
        var data = this.dashboardUpdatesData.find(data => {
          if(data.productId == $id){
            return data.open;
          }
        });
        return data;
      }
    },
  },
}
</script>


<style>
.postionRealtive{
  position: relative;
}
.DashboardBoxBackendSetting{
    min-height: 100px !important;
}
.CenterText .v-toolbar__content{
  display:inline-flex !important;
}
.notificationForDashboard .v-badge__badge{
  min-width:18px !important;
  height:18px !important;
  font-size:10px !important;
}
.updateButtonSetting{
  position:absolute;
  bottom:-18px;
  left: 50%;
  transform: translate(-50%, 0%);
}
.cardShadow{
  box-shadow: 5px 5px 7px 0px rgba(00,00,00,0.2) !important;
}
.smalltext{
  font-size: 13.5px !important;
  line-height: 30px;  
  font-weight: 500 !important;
}
.toobarDashboard .v-toolbar__content{
  height: auto !important;
}
.buttonanimation2 {
  background-color: #fdd10d;
  -webkit-animation-name: example; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 0.5s; /* Safari 4.0 - 8.0 */
  animation-name: btnanimation2;
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes btnanimation2 {
  from {background-color: rgb(1, 117, 117);}
  to {background-color: #fdd10d;}
}

/* Standard syntax */
@keyframes btnanimation2 {
  from {background-color:rgb(1, 117, 117);}
  to {background-color: #fdd10d;}
}


.buttonanimation {
  background-color: #455a64;
  -webkit-animation-name: example; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 0.5s; /* Safari 4.0 - 8.0 */
  animation-name: btnanimation;
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes btnanimation {
  from {background-color: red;}
  to {background-color: #455a64;}
}

/* Standard syntax */
@keyframes btnanimation {
  from {background-color:red;}
  to {background-color: #455a64;}
}
</style>